// extracted by mini-css-extract-plugin
export default {"projectInfo":"Dlrn9ik5MhGsEugWBe7g","projectInfoRow":"mSs5YMKLbrgiYNTlNxVN","projectInfoLabel":"BJOE3P6DqxwZVzNYgALu"};